// /client/packs/controllers/email_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  validate() {
    const input = this.inputTarget
    const email = input.value.trim()
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    let error = input.parentNode.querySelector(".invalid-feedback")
    const submitBtn = this.inputTarget.closest(".btn")

    if (!emailRegex.test(email)) {
      input.classList.add("is-invalid")
      if (!error) {
        error = document.createElement("div")
        error.classList.add("invalid-feedback")
        error.innerText = "Invalid email address"
      }
      input.parentNode.insertBefore(error, input.nextSibling)
    } else {
  
      if (error) {
        input.classList.remove("is-invalid")
        error.remove()
      }
    }
  
  }
}